import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IWorkspaceResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IWorkspaceResponseInstance'

export function mapWorkspaceResponseInstance(workspace: IToJson<IWorkspaceResponseInstance>): IWorkspaceResponseInstance {
  return workspace
}
